/**
 * Created by fd on 2021-09-22 (13:39).
 */
import LanguageManager from "Sources/services/language-manager";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/rental-service.html";

require("Styles/components/popup/rental-service.scss");

const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);

class RentalServiceView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.resourceType = options.resourceType;
        this.canAddResources = options.canAddResources;
        this.productCount = options.productCount;
        this.resourceCount = options.resourceCount;
        this.rental = options.rental;
    }

    render()
    {
        super.render();

        this._setUpEventListeners();

        this.$element.find(".resource-type-phone").hide();
        this.$element.find(".resource-type-bike").hide();
        this.$element.find(".resource-type-" + this.resourceType).show();

        let receiveMesssage = LanguageManager.getValueForKey("rentalservice.info");

        receiveMesssage = receiveMesssage.replaceAll("{coins-icon}", this.getCoinsIcon());
        receiveMesssage = receiveMesssage.replaceAll("{price}", this.getRentalInfo().price);

        this.$element.find("#rental_service_receive_cell").html(receiveMesssage);

        this.$element.find(".rental_service_add_resources").hide();

        if (this.canAddResources)
        {
            this.$element.find(".rental_service_add_resources").show();
        }

        this.updateLabels();

        this.onRender();
    }

    updateEarnings()
    {
        let info = this.getRentalInfo();

        let earningsMessage = LanguageManager.getValueForKey("rentalservice.earnings");

        earningsMessage = earningsMessage.replaceAll("{coins-icon}", this.getCoinsIcon());
        earningsMessage = earningsMessage.replaceAll("{amount}", info.totalAmount * info.price);

        this.$element.find("#rental_service_earnings_cell").html(earningsMessage);
    }

    updatePhases()
    {
        let info = this.getRentalInfo();

        this.$element.find(".max-resource-value").text(this.productCount - info.amount);

        this.$element.find(".rental-use-phase-1").text(info.amount);
        this.$element.find(".rental-use-phase-2").text(this.getRentalProductCountForPhase(1));
        this.$element.find(".rental-use-phase-3").text(this.getRentalProductCountForPhase(2));
        this.$element.find(".rental-garbage").text(this.getRentalProductCountForPhase(3));

        if (this.getIsUsingResources())
        {
            if (this.rental)
            {
                let reusedProducts = Math.min(this.rental.phase3, this.resourceCount);

                this.$element.find(".rental-use-phase-1").text(info.amount + reusedProducts);
                this.$element.find(".rental-garbage").text(this.getRentalProductCountForPhase(3) - reusedProducts);
            }
        }
    }

    updateResourceCost()
    {
        let resourceCost = 0;

        if (this.getIsUsingResources())
        {
            if (this.rental)
            {
                resourceCost = Math.min(this.rental.phase3, this.resourceCount) * -1;
            }
        }

        this.$element.find(".rental-service-resource-cost").text(resourceCost);
    }

    getCoinsIcon()
    {
        return "<img src='" + resourceIcons("./coins.svg") + "' />";
    }

    getRentalInfo()
    {
        return {
            addResource: this.getIsUsingResources(),
            amount: this.getNewAmountOfProductsForRent(),
            totalAmount: this.getTotalAmountOfProductsForRent(),
            price: this.getRentPrice()
        };
    }

    _setUpEventListeners()
    {
        let input = this.$element.find("input.counter-input");
        let instance = this;
        let maxValue = this.productCount;

        this.$element.find(".counter-increase").off("click").on("click", () =>
        {
            adjustCounter(1);
        });

        this.$element.find(".counter-decrease").off("click").on("click", () =>
        {
            adjustCounter(-1);
        });

        this.$element.find(".counter-input").off("focusout").on("focusout", () =>
        {
            adjustCounter(0);
        });

        // this.$element.find("#rental-service-add-resource-input-label").off("click").on("click", () =>
        // {
        //     this.$element.find("#rental-service-add-resource-input").click();
        // });

        this.$element.find("#rental-service-add-resource-input").off("change").on("change", () =>
        {
            this.updateLabels();
        });

        function adjustCounter(delta)
        {
            let value = parseInt(input.val()) + delta;

            if (value < 0 || isNaN(value))
            {
                value = 0;
            }

            if (value > maxValue)
            {
                value = maxValue;
            }

            input.val(value);

            instance.updateLabels();
        }
    }

    updateLabels()
    {
        this.updateEarnings();
        this.updatePhases();
        this.updateResourceCost();

        this.$element.find("#rental-service-add-resource-input").prop("disabled", !this.getCanAddResources());
    }

    getRentalProductCountForPhase(phase)
    {
        if (!this.rental) return 0;

        switch (phase)
        {
            case 1:
                return this.rental.phase1;
            case 2:
                return this.rental.phase2;
            case 3:
                return this.rental.phase3;
        }
        return 0;
    }

    getCanAddResources()
    {
        if (this.getRentalProductCountForPhase(3) === 0)
        {
            return false;
        }

        if (this.resourceCount <= 0)
        {
            return false;
        }

        return true;
    }

    getIsUsingResources()
    {
        return $("#rental-service-add-resource-input").is(":checked");
    }

    getNewAmountOfProductsForRent()
    {
        let input = parseInt(this.$element.find("input.counter-input").val());
        return isNaN(input) ? 0 : input;
    }

    getTotalAmountOfProductsForRent()
    {
        let input = parseInt(this.$element.find("input.counter-input").val());

        let inputValue = isNaN(input) ? 0 : input;
        let alreadyInCirculation = 0;

        if (this.rental)
        {
            alreadyInCirculation += this.rental.phase1;
            alreadyInCirculation += this.rental.phase2;
        }

        let refurbish = 0;
        if (this.getIsUsingResources() && this.rental)
        {
            refurbish = Math.min(this.rental.phase3, this.resourceCount);
        }

        return inputValue + alreadyInCirculation + refurbish;
    }

    getRentPrice()
    {
        switch (this.resourceType)
        {
            case "phone":
                return 3;
            case "bike":
                return 4;
        }
        return 0;
    }
}

module.exports = RentalServiceView;



// WEBPACK FOOTER //
// ./app/js/components/popup/rental-service.js